<template>
  <div>
    <b-modal id="edit-file-modal" title="Modifica file" centered>
      <form>
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <label for="">Nome file</label>
              <input type="text" class="form-control" v-model="name" />
            </div>
            <div class="col-6">
              <label for="">Tag</label>
              <select class="form-control" v-model="tag">
                <option value="null">Seleziona tag...</option>
                <option
                  :value="tag.uuid"
                  v-for="(tag, index) in tags"
                  :key="index"
                >
                  {{ tag.value }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-6">
              <label for="">Tipologia file</label>
              <select class="form-control" v-model="fileType">
                <option value="null">Seleziona tipologia file...</option>
                <option
                  :value="fileType.uuid"
                  v-for="(fileType, index) in fileTypes"
                  :key="index"
                >
                  {{ fileType.value }}
                </option>
              </select>
            </div>
            <div class="col-6">
              <label for="">Categoria</label>
              <select class="form-control" v-model="category">
                <option value="null">Seleziona categoria...</option>
                <option
                  :value="category.uuid"
                  v-for="(category, index) in categories"
                  :key="index"
                >
                  {{ category.value }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-6">
              <label for="">Anno</label>
              <select class="form-control" v-model="year">
                <option value="null">Seleziona tipologia file...</option>
                <option
                  :value="year.uuid"
                  v-for="(year, index) in years"
                  :key="index"
                >
                  {{ year.value }}
                </option>
              </select>
            </div>
            <div class="col-6">
              <label for="">Brand</label>
              <select class="form-control" v-model="brand">
                <option value="null">Seleziona brand...</option>
                <option
                  :value="brand.uuid"
                  v-for="(brand, index) in brands"
                  :key="index"
                >
                  {{ brand.value }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="">Descrizione</label>
              <textarea
                cols="30"
                rows="5"
                class="form-control"
                v-model="description"
              ></textarea>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <div class="thumbnail-area mb-3" v-if="thumbnail">
                <span @click="clearThumbnail()">X</span>
                <img
                  :src="thumbnail"
                  alt=""
                  class="img-fluid"
                />
              </div>

              <label for="">Miniatura</label>
              <input
                class="form-control"
                type="file"
                id="thumb-input"
                @change="saveThumb"
              />
              <small style="font-style: italic"
                >Lascia vuoto questo campo se non vuoi modificare la miniatura
                attuale</small
              >
            </div>
          </div>
        </div>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <LoadingButton
            :text="ctaText"
            :classes="['btn-primary', 'w-100']"
            :loading="loading"
            :disabled="
              $v.$invalid || !category || !fileType || !year || !brand || !tag
            "
            @click="editFile()"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import UploaderService from "@/services/uploader";
import FilesService from "@/services/files";

export default {
  props: ["fileTypes", "categories", "years", "brands", "tags", "file"],
  data() {
    return {
      ctaText: "Modifica file",
      name: "",
      description: "",
      thumbnail: null,
      loading: false,
      category: null,
      fileType: null,
      year: null,
      brand: null,
      tag: null,
      files: [],
      thumbs: [],
    };
  },
  validations: {
    name: {
      required,
    },
  },
  watch: {
    file: function (newFile) {
      try {
        this.name = newFile.fileName;
        this.tag = newFile.tag.uuid;
        this.fileType = newFile.fileType.uuid;
        this.category = newFile.category.uuid;
        this.year = newFile.year.uuid;
        this.brand = newFile.brand.uuid;
        this.description = newFile.description;
        this.thumbnail = newFile.thumbnail ? newFile.thumbnail : null;
      } catch (error) {}
    },
  },
  methods: {
    saveThumb(event) {
      this.thumbs = event.target.files;
    },

    clearThumbnail() {
      this.thumbnail = null;
      this.file.thumbnail = null;
    },

    async createNewFile(url) {
      const body = {
        fileName: this.name,
        description: this.description,
        brand: this.getBrand(),
        tag: this.getTag(),
        category: this.getCategory(),
        fileType: this.getFileType(),
        year: this.getYear(),
        url,
      };

      await FilesService.addFile(this.$db, body);

      this.loading = false;

      this.$emit("uploaded", true);
      this.$root.$emit("bv::hide::modal", "upload-file-modal");
    },

    async editFile() {
      this.loading = true;

      const body = {
        fileName: this.name,
        description: this.description,
        brand: this.getBrand(),
        tag: this.getTag(),
        category: this.getCategory(),
        fileType: this.getFileType(),
        year: this.getYear(),
      };

      // Upload Thumbnail
      if (this.thumbs.length) {
        const thumbUrls = await UploaderService.uploadFile(
          this.thumbs,
          "thumbnail"
        );

        this.thumbnail = thumbUrls[0];
      }

      body.thumbnail = this.thumbnail;

      await FilesService.updateFile(this.$db, this.file.uuid, body);

      this.loading = false;

      this.$emit("edited", true);
      this.$root.$emit("bv::hide::modal", "edit-file-modal");
      this.thumbnail = null;
      this.thumbs = [];
    },

    getCategory() {
      return this.categories.find(
        (category) => category.uuid === this.category
      );
    },

    getFileType() {
      const fileType = this.fileTypes.find(
        (fileType) => fileType.uuid === this.fileType
      );

      return {
        uuid: fileType.uuid,
        value: fileType.value,
      };
    },

    getYear() {
      return this.years.find((year) => year.uuid === this.year);
    },

    getBrand() {
      return this.brands.find((brand) => brand.uuid === this.brand);
    },

    getTag() {
      return this.tags.find((tag) => tag.uuid === this.tag);
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail-area {
  position: relative;

  span {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #000;
    background: #fff;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.9em;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/EditFileDialog.vue